import React from "react";
const HeroSection: React.FC = () => {
  return <div className="flex flex-col md:flex-row items-center gap-6 mb-8">
      <div className="md:w-1/2 space-y-3">
        <h1 className="font-playfair mb-2 text-slate-900 text-left py-[31px] text-5xl font-normal">
          All faiths make claims.<br /> 
          <span className="text-heaven-gold">Only one Gospel saves.</span>
        </h1>
        <p className="text-[#403E43]/80 mb-4 text-base text-left">
          Selah helps you engage other religions with biblical truth and Christlike clarity.
        </p>
        <div className="text-[#403E43]/80 text-sm text-left">
          <p className="mb-3 text-left">
            From Islam to Hinduism, from Judaism to Mormonism—many belief systems claim to know the truth about God. 
            But only one gospel declares Jesus Christ as the way, the truth, and the life.
          </p>
          <p className="mb-3 text-left">The Interfaith Dialogue Tool equips you to engage others respectfully while standing firm on biblical truth. Every response draws from Scripture, and lifts high the name of Jesus without compromise.</p>
          <p className="text-left">
            This tool isn't about debate. It's about defending truth, correcting error, and winning souls—with boldness, 
            love, and the authority of God's Word.
          </p>
        </div>
      </div>
      <div className="md:w-1/2">
        <img src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Why%20(4).png" alt="Interfaith Dialogue" className="rounded-lg shadow-md w-full h-72 object-cover object-center" />
      </div>
    </div>;
};
export default HeroSection;
